<template>

  <li v-if="link.sublinks.length == 0  && link.type!='item item-divider' " class="nav-item toolbar-link" @click="openSubLinkOrRedirect(link)"
      style="width: 200px;position:relative">
    <a class="nav-link active" aria-current="page" data-bs-dismiss="offcanvas" style="min-width:300px"
       :style="{'color':primaryColor + '!important'}"> <i
        class="canvas-item-icon mobile-activated" :class="link.icon_style"></i> {{ link.title[currentLanguage] }} </a><span
      v-if="link.target == '#/app/posts' && unreadNews > 0"
      class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
      style="top:20px">
                {{ unreadNews }}
              </span>
  </li>

  <li v-if="link.sublinks.length > 0 && link.type!='item item-divider'" class="mobile-activated">
    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
       data-bs-toggle="dropdown" aria-expanded="false" style="margin-left:20px;"
       :style="{'color':primaryColor + '!important'}">
      <i class="canvas-item-icon mobile-activated" :class="link.icon_style"></i>
      <div style="display:inline-block; width:210px; line-height:1rem;  white-space: normal;"> {{ link.title[currentLanguage] }}</div>
    </a>
    <div style="box-shadow: none !important" class="dropdown-menu toolbar-submenu"
         aria-labelledby="navbarDropdownMenuLink">
      <div v-for="sublink in link.sublinks" :key="sublink.id">
        <a @click="openSubLinkOrRedirect(sublink)"
           style="margin-left: 20px; white-space: normal;max-width: 250px;"
           :style="{'color':primaryColor + '!important'}"
           class="dropdown-item"
           data-bs-dismiss="offcanvas">{{ sublink.title[currentLanguage] }} </a>
        <hr class="dropdown-divider mobile-activated" style="border-top:none">
      </div>
    </div>
  </li>
  <li v-if="link.sublinks.length == 0 && link.type=='item item-divider'" class=" mobile-activated">
    <b > {{ link.title[currentLanguage]}} </b>
    <hr style="border-width: 1px; padding: 0; margin: 3px 0 0 0 ">
  </li>
  <hr v-if="link.sublinks.length > 0 && link.type=='item item-divider'">

</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import {addIcons} from "ionicons";
import {
  personCircleOutline,
  chatbubbleOutline,
  syncOutline,
  logOutOutline,
  logInOutline,
  searchCircleOutline,
  homeOutline,
  chevronBackOutline,
  cloudOfflineOutline,
  menuOutline
} from "ionicons/icons";

addIcons({
  "sync-outline": syncOutline,
  "person-circle-outline": personCircleOutline,
  "log-out-outline": logOutOutline,
  "log-in-outline": logInOutline,
  "chatbubble-outline": chatbubbleOutline,
  "search-circle-outline": searchCircleOutline,
  "home-outline": homeOutline,
  "chevron-back-outline": chevronBackOutline,
  'cloud-offline-outline': cloudOfflineOutline,
  "menu-outline": menuOutline,
});
const config = require('@/config')
import router from '@/router';
import {alertController, isPlatform} from "@ionic/vue";
import {store} from "@/store";

export default {
  components: {},
  props: ['link'],
  data() {
    return {
      menulinks: [],
      menulinksTop: [],
      title: config.full_name,
      isConsultant: false,
      userConsultant: null,
      isDesktop: null,
      isIos: null,
      video_chat_enabled: false,
      confDate: config.conf_date,
      openSubBar: false,
      sublinks: null,
      time: null,
      appointmentsRole: null,
      searchterm: '',
      hideSearchBar: false,
      historyCount: 0,
      loginAlertOpen: false,
      onLine: navigator.onLine,
      showBackOnline: false
    }
  },
  computed: {
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress']),
    ...mapGetters('auth', ['user']),
    ...mapState('splashscreen', ['showSplashscreen']),
    ...mapState('personalDB', ['unreadNews']),
    ...mapState('chat', ['currentChat', 'unreadTotal']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapState('currentConference', ['currentConference', 'fullName', 'shortName', 'apiVersion', 'primaryColor', 'menuheader']),
  },
  methods: {
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions('sync', ['start']),
    ...mapActions("exhibitors", ["getAllExhibitors"]),
    ...mapActions('menulinks', ['isExternalLink']),
    ...mapActions('auth', ['GET_USERDATA']),
    ...mapMutations('splashscreen', ['setShowSplash']),
    ...mapActions("personalDB", ["connectPersonalDB", 'getItem', 'getItems', 'prepareFavoriteList', 'setTime', 'getUnreadNews']),
    ...mapMutations('personalDB', ['setUnreadNews']),
    ...mapActions('chat', ['getUnreadMessagesTotalCount']),
    ...mapActions('googleanalytics', ['trackWithLabel']),


    goToChat() {
      if (this.user && this.user.id) {
        this.$router.push('/app/chat/');
      } else {
        this.chatAlert()
      }
    },
    async loginAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'You need to be logged in in order to access.',
            message: 'Do you want to log in?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'Confirm',
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },

    async chatAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'You need to be logged in in order to access the chat.',
            message: 'Do you want to log in?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'Confirm',
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },

    async loginByToken(tokenSent) {
      //check for token in path
      let token = tokenSent
      if (token) {

        localStorage.setItem("x-api-key", token);

        let userRequest = await store.dispatch("auth/GET_USERDATA");
        //this.user = userRequest.data;

        let tmpUser = userRequest.data;

        if (tmpUser) {

          await store.commit("auth/SET_USER", tmpUser);
          localStorage.setItem('user', JSON.stringify(tmpUser));
        }
        //splice the path
        window.history.pushState(
            {},
            document.title,
            '/'
        );
        router.push({name: 'Dashboard'});

      } else {
        router.next();
      }
      router.next();

    },


    async login() {
      console.log("login")
      let self = this
      localStorage.setItem('lastPageBeforeLogin', location.hash);
      //let frontendKey = config.auth_key;
      if (isPlatform('ios') && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line

        let redirect = (param) => {
          console.log('PARAM', param)
          if (param && param.indexOf('token=') != -1) {
            let token = param.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        }

        ref.addEventListener('loaderror', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
        ref.addEventListener('loadstart', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });


      } else if (isPlatform('android') && typeof cordova != 'undefined') {

        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key, '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line
        ref.addEventListener('loaderror', function (event) {

          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
      } else {
        console.log("essta")
        //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
        window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

      }

    },

    async openSubLinkOrRedirect(link) {
      this.trackWithLabel('menu_link:' + link.title.en)

      console.log('OPEN LINK', link.type)

      if(link.id == '9ebe7ebb-c745-4c49-9b2c-b250ee941c47'){
        this.goToChat()
      }else if (link.id == '69f7cbf5-fdac-412d-9b76-6b64a89e0e34') {
        if (this.user && this.user.id) {
          let external = await this.isExternalLink(link.redirect)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {

            console.log('REDIRECT', link)
            router.push(link.redirect);
          }
        } else {
          this.loginAlert()
        }
      }else{
        if( link.type!='item item-divider'){
          if (link.sublinks && link.sublinks.length > 0 ) {

            this.openSubBar = !this.openSubBar;
            if (this.sublinks == []) {
              this.sublinks = link.sublinks
            } else {
              this.sublinks = [];
            }
          } else {
            let external = await this.isExternalLink(link.target)
            if (external) {
              window.open(link.redirect, '_blank').focus();
            } else {
              router.push(link.redirect);
            }
          }
        }
      }


    },
  },

  mounted() {
  },
  beforeUnmount() {
  },

  watch: {}

};
</script>

